import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './PayOnlineEntryHeader.scss';
import SortIcons from '../../../../modules/react/components/stateless/PlaceholderIcon';

const { UpArrow, DownArrow, UpDownArrow } = SortIcons;

const PayOnlineEntryHeader = ({ onClickSort = () => {}, sortConfig = { key: null, direction: 'ascending' }, showSort = true }) => {
  const createSortHandler = field => () => {
    onClickSort(field);
  };
  const renderSortableHeader = (field) => {
    if (!showSort) {
      return null; // or whatever you want to return when showSort is false
    }
    const isSorting = field === sortConfig.key;
    const isAscending = sortConfig.direction === 'ascending';

    let icon;
    if (isSorting) {
      icon = isAscending ? <UpArrow /> : <DownArrow />;
    } else {
      icon = <UpDownArrow />;
    }

    return (
      <span
        role="button"
        tabIndex={0}
        className={styles.hederSVG}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === 'Space') {
            onClickSort(field);
          }
        }}
        data-testid={`sorting-button-${field}`}
      >
        {icon}
      </span>
    );
  };


  return (
    <>
      <Container className={styles.customGrid}>
        <Row className={styles.heading}>
        <Col onClick={createSortHandler('displayName')} sm={2} className={`${styles.sortClick} d-none d-sm-none d-md-block`}>
        Facility
        {renderSortableHeader('displayName')}
        </Col>
          <Col onClick={createSortHandler('address.address1')} sm={2} data-testid="address-header" className={`${styles.sortClick} d-none d-sm-none d-md-block`}>
          Address
          {renderSortableHeader('address.address1')}
          </Col>
          <Col onClick={createSortHandler('address.city')} sm={2} data-testid="city-header" className={`${styles.sortClick} d-none d-sm-none d-md-block`}>
          City
          {renderSortableHeader('address.city')}
          </Col>
          <Col sm={2} className="d-none d-sm-none d-md-block">
            Zip
          </Col>
          <Col sm={2} className="d-none d-sm-none d-md-block">
            Phone
          </Col>
        </Row>
      </Container>
      <hr className={styles.divider} />
    </>
  );
};

export default PayOnlineEntryHeader;
